import React from 'react'

const ESDSafe = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">ESD Lab Setup</a>
                        <i class="fa fa-angle-right"></i>
                        <span>ESD Safe Conveyor</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/esdsafe.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>ESD Safe Conveyor:</h2>
                        <p className="mbot25">
                            <b style={{ textDecoration: "underline", marginRight: '5px' }}>Description:</b>
                            An ESD safe conveyor is used in assembly lines
                            to transport electronic components and devices without the
                            risk of static damage. These conveyors are built with static-
                            dissipative materials and grounding mechanisms to maintain
                            an ESD-safe environment. They facilitate efficient handling
                            and movement of products while ensuring that sensitive
                            components are not exposed to harmful electrostatic
                            discharge.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ESDSafe
